import { FAQS } from "../../data/site";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export const FaqSection = () => {
    return (
        <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 bg-[#141414] border-t border-[#262626]">
            <div className="max-w-3xl mx-auto px-6">
                <p className="text-[#E60000] font-bold uppercase tracking-[0.3em] text-sm mb-4 text-center">FAQ</p>
                <h2 data-testid="faq-title" className="text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white text-center">
                    Domande frequenti
                </h2>
                <Accordion type="single" collapsible className="mt-12 space-y-3">
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="border border-[#262626] bg-[#0A0A0A] px-6"
                        >
                            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-white font-semibold uppercase tracking-tight text-left hover:no-underline hover:text-[#E60000]">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-neutral-400 leading-relaxed">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};
